export const FLAG_TYPES = ['incorrect', 'unhelpful', 'bad_tone', 'confused', 'other'] as const

export type FlagType = typeof FLAG_TYPES[number]
